import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-pre-login',
  templateUrl: './pre-login.component.html',
  styleUrls: ['./pre-login.component.scss']
})
export class PreLoginComponent implements OnInit, OnDestroy {

  currentStage = 1;
  maxStage = 2;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.currentStage = 1;
  }

  next() {
    this.currentStage++;
  }

}
